import { isFunction } from 'lodash'
import { isValidString } from './string'

/**
 * Helper function to read css computed styles from the document. Used for gettting
 * css custom property values within javascript.
 *
 * Attention: When using JSDom in unit tests these function will return an empty string
 * (because JSDom provides noop implementations of getComputedStyle and getPropertyValue),
 * if you want to test for a certain behaviour you should use the fallback parameter.
 *
 * @example
 * // CSS variable declaration
 * :root {
 *     --my-css-custom-property: 12px
 * }
 *
 * // Read css variable via JavaScript
 * getPropertyValue(--my-css-custom-property) === '12px'
 *
 * @param {string} propertyValue - The name to be read
 * @param {string|number} [fallback=''] - The fallback to be used if propertyValue is not set
 * @returns {string|number} The corresponding css custom property value set on the :root level
 */
export function getPropertyValue(propertyValue, fallback = '') {
    if (!isFunction(getComputedStyle) || !isValidString(propertyValue)) {
        return String(fallback).trim()
    }

    const cssDeclaration = getComputedStyle(document.documentElement)
    const value = isFunction(cssDeclaration.getPropertyValue) && cssDeclaration.getPropertyValue(propertyValue)

    return value.trim() || String(fallback).trim()
}
